import {
  bedroomEnum,
  ownerStatusEnum,
  propertyStatusEnum,
  tenantStatusEnum,
  documentStatusEnum,
  propertyKindEnum,
  ownerKindEnum,
  planPaymentEnum,
  propertyRatesStatusEnum,
  propertyBillingEnum,
  verificationStatusEnum,
  paymentMethodEnum,
  claimConfirmationTypeEnum,
  claimStatusEnum,
  planStatusEnum,
  statesEnum,
  planIncomeControlledEnum,
  studentStatusEnum,
  schoolLevelEnum,
  leaseCategoryEnum,
  permissionActionEnum,
  permissionPropertyFilterEnum,
  leaseTypeEnum,
  coverageInterestKeyMap,
  coverageTypeEnum,
} from "common/utils/enums";
import { toTitleCase } from "common/utils/misc";
import { backgroundTypeEnum, permissionStatusEnum } from "./enums";

export const tenantStatusOptions = [
  { label: tenantStatusEnum.NEW, value: tenantStatusEnum.NEW },
  { label: tenantStatusEnum.INVITED, value: tenantStatusEnum.INVITED },
  { label: tenantStatusEnum.ACCEPTED, value: tenantStatusEnum.ACCEPTED },
  { label: tenantStatusEnum.DELETED, value: tenantStatusEnum.DELETED },
];

export const ownerStatusOptions = [
  { label: ownerStatusEnum.ACTIVE, value: ownerStatusEnum.ACTIVE },
  { label: ownerStatusEnum.DELETED, value: ownerStatusEnum.DELETED },
];

export const ownerKindOptions = [
  { label: ownerKindEnum.OWNER, value: ownerKindEnum.OWNER },
  { label: ownerKindEnum.MANAGER, value: ownerKindEnum.MANAGER },
];

export const propertyStatusOptions = [
  { label: propertyStatusEnum.INACTIVE, value: propertyStatusEnum.INACTIVE },
  { label: propertyStatusEnum.OPTOUT, value: propertyStatusEnum.OPTOUT },
  { label: propertyStatusEnum.OPTIN, value: propertyStatusEnum.OPTIN },
  { label: propertyStatusEnum.REQUIRED, value: propertyStatusEnum.REQUIRED },
];

export const propertyKindOptions = [
  {
    label: "Multifamily",
    value: propertyKindEnum.MULTIFAMILY,
  },
  {
    label: "Student Housing",
    value: propertyKindEnum.STUDENT,
  },
  {
    label: "Other",
    value: propertyKindEnum.OTHER,
  },
];

export const documentStatusOptions = [
  { label: "None", value: documentStatusEnum.NONE },
  { label: "Uploaded", value: documentStatusEnum.UPLOADED },
  { label: "Rejected", value: documentStatusEnum.REJECTED },
  { label: "Verified", value: documentStatusEnum.VERIFIED },
];

export const verificationStatusOptions = [
  { label: "Verified", value: verificationStatusEnum.VERIFIED },
  { label: "Not Verified", value: verificationStatusEnum.NOT_VERIFIED },
];

export const adminStatusOptions = [
  {
    label: "Submitted",
    value: "Submitted",
  },
  {
    label: "Completed",
    value: "Completed",
  },
  {
    label: "In Review",
    value: "In Review",
  },
  {
    label: "Expired",
    value: "Expired",
  },
  {
    label: "Denied",
    value: "Denied",
  },
  {
    label: "Approved",
    value: "Approved",
  },
  {
    label: "Confirmed",
    value: "Confirmed",
  },
];

export const relationshipStatusOptions = [
  {
    label: "Single",
    value: "single",
  },
  {
    label: "Married",
    value: "married",
  },
  {
    label: "Common law",
    value: "commonLaw",
  },
  {
    label: "Non-common law cohabitating relationship",
    value: "nonCommonCohab",
  },
];
export const residencyStatusOptions = [
  {
    label: "Citizen or Permanent Resident",
    value: "citizenPermanent",
  },
  {
    label: "Employer-Sponsored Work Visa (i.e. Closed)",
    value: "employerVisa",
  },
  {
    label: "Other Visa Work (i.e. Open)",
    value: "otherVisa",
  },
  {
    label: "Student Visa",
    value: "studentVisa",
  },
  {
    label: "Other Temporary Visa",
    value: "otherTemporaryVisa",
  },
];

export const highestEducationLevelOptions = [
  {
    label: "Select education level",
    value: "",
  },
  {
    label: "High School Diploma",
    value: "highSchoolGed",
  },
  {
    label: "Community College or Trade School Certification",
    value: "communityTrade",
  },
  {
    label: "Associate Degree",
    value: "associate",
  },
  {
    label: "Bachelors Degree",
    value: "bachelor",
  },
  {
    label: "Masters",
    value: "master",
  },
  {
    label: "PhD",
    value: "phd",
  },
  {
    label: "No degree",
    value: "none",
  },
];

export const planCurrencyOptions = [
  {
    label: "US Dollars",
    value: "USD",
  },
  {
    label: "Euros",
    value: "EUR",
  },
  {
    label: "Canadian Dollars",
    value: "CAD",
  },
];

export const paymentMethodOptions = [
  {
    label: "Wire Transfer",
    value: paymentMethodEnum.WIRE,
  },
  {
    label: "ACH",
    value: paymentMethodEnum.ACH,
  },
  {
    label: "Check",
    value: paymentMethodEnum.CHECK,
  },
  {
    label: "E-Transfer",
    value: paymentMethodEnum.ETRANSFER,
  },
];

export const paymentPlanOptions = [
  {
    label: "Monthly",
    value: planPaymentEnum.MONTHLY,
  },
  {
    label: "One-Time",
    value: planPaymentEnum.ONETIME,
  },
];

export const claimConfirmationOptions = [
  {
    label: "Unit Vacated",
    value: claimConfirmationTypeEnum.VACATED,
  },
  {
    label: "Member Account Current",
    value: claimConfirmationTypeEnum.CURRENT,
  },
  {
    label: "Unit Re-Listed",
    value: claimConfirmationTypeEnum.RELISTED,
  },
];

export const claimStatusOptions = [
  { label: "Draft", value: claimStatusEnum.DRAFT },
  { label: "Submitted", value: claimStatusEnum.SUBMITTED },
  { label: "In Review", value: claimStatusEnum.IN_REVIEW },
  { label: "Resolved", value: claimStatusEnum.RESOLVED },
  { label: "Approved", value: claimStatusEnum.APPROVED },
  { label: "Confirmed", value: claimStatusEnum.CONFIRMED },
  { label: "Completed", value: claimStatusEnum.COMPLETED },
  { label: "Expired", value: claimStatusEnum.EXPIRED },
  { label: "Cancelled", value: claimStatusEnum.CANCELLED },
];

export const allPlanStatusOptions = [
  { label: "Created", value: planStatusEnum.CREATED },
  { label: "Pending", value: planStatusEnum.PENDING },
  { label: "Quote", value: planStatusEnum.QUOTE },
  { label: "Activation Required", value: planStatusEnum.ACTIVATION_REQUIRED },
  { label: "Review", value: planStatusEnum.REVIEW },
  { label: "Active", value: planStatusEnum.ACTIVE },
  { label: "Not Eligible", value: planStatusEnum.REJECTED },
  { label: "Complete", value: planStatusEnum.COMPLETE },
  { label: "Cancelled", value: planStatusEnum.CANCELLED },
  { label: "Suspended", value: planStatusEnum.SUSPENDED },
  { label: "Ongoing Claim", value: planStatusEnum.ON_GOING_CLAIM },
  { label: "Closed", value: planStatusEnum.CLOSED },
  { label: "Expired", value: planStatusEnum.EXPIRED },
  { label: "Not Eligible", value: planStatusEnum.NOT_ELIGIBLE },
];

export const booleanOptions = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

export const stateOptions = Object.entries(statesEnum).map(([key, value]) => ({
  label: toTitleCase(key),
  value: value,
}));

export const propertyRatesStatusOptions = Object.entries(
  propertyRatesStatusEnum,
).map(([key, value]) => ({
  label: toTitleCase(value),
  value: value,
}));

export const propertyBillingOptions = Object.entries(propertyBillingEnum).map(
  ([key, value]) => ({
    label: toTitleCase(value),
    value: value,
  }),
);

export const planIncomeControlledOptions = Object.entries(
  planIncomeControlledEnum,
).map(([key, value]) => ({
  label: toTitleCase(value),
  value: value,
}));

export const bedroomOptions = [
  { label: "Studio", value: bedroomEnum.STUDIO },
  { label: "1 Bedroom", value: bedroomEnum.ONE_BED },
  { label: "2 Bedrooms", value: bedroomEnum.TWO_BED },
  { label: "3 Bedrooms", value: bedroomEnum.THREE_BED },
  { label: "4+ Bedrooms", value: bedroomEnum.FOUR_BED_PLUS },
];

/**
 * Filter bedroom options based on property rates
 * Only shows options that have actual rates and numbers associated in the rental unit breakdown
 * @param {Object} property - The property object containing rates
 * @param {string} currentValue - Current selected value to ensure it's included even if not in breakdown
 * @returns {Array} Filtered bedroom options
 */
export const getFilteredBedroomOptions = (property, currentValue = null) => {
  if (!property?.rates?.underwriting?.rentalUnitBreakdown) {
    return bedroomOptions;
  }

  const breakdown = property.rates.underwriting.rentalUnitBreakdown;
  
  const filteredOptions = bedroomOptions.filter(option => {
    const unitData = breakdown[option.value];
    return unitData && unitData.numberOfUnits > 0 && unitData.averageRent > 0;
  });

  // If current value is not in filtered options but exists in breakdown, add it
  if (currentValue && !filteredOptions.find(option => option.value === currentValue)) {
    const currentOption = bedroomOptions.find(option => option.value === currentValue);
    if (currentOption) {
      filteredOptions.push(currentOption);
    }
  }

  return filteredOptions;
};

export const studentStatusOptions = Object.entries(studentStatusEnum).map(
  ([key, value]) => ({
    label: toTitleCase(value),
    value: value,
  }),
);

export const schoolLevelOptions = [
  { label: "Undergraduate Program", value: schoolLevelEnum.UNDERGRADUATE_PROGRAM },
  { label: "Graduate Program", value: schoolLevelEnum.GRADUATE_PROGRAM },
];

export const leaseCategoryOptions = [
  { label: "New Lease", value: leaseCategoryEnum.NEW },
  { label: "Lease Renewal", value: leaseCategoryEnum.RENEWAL },
];

export const propertyFilterOptions = [
  {
    label: "All Properties",
    value: permissionPropertyFilterEnum.PROPERTY_FILTER_ALL,
  },
  {
    label: "Only Assigned Properties",
    value: permissionPropertyFilterEnum.PROPERTY_FILTER_ASSIGNED,
  },
];

// Options for permission actions (using Checkboxes instead of Select for multi-choice)
// You might create a helper function or map directly in the component
export const propertyAndPlansActions = [
  { label: "View", value: permissionActionEnum.ACTION_VIEW },
  { label: "Create", value: permissionActionEnum.ACTION_CREATE },
  { label: "Edit", value: permissionActionEnum.ACTION_EDIT },
];

export const claimsActions = [
  { label: "View", value: permissionActionEnum.ACTION_VIEW },
  // Add CREATE/EDIT if applicable based on your business logic for managers
  // { label: 'Create/Edit', value: permissionActionEnum.ACTION_CREATE },
];

export const invoicesActions = [
  { label: "View", value: permissionActionEnum.ACTION_VIEW },
];

export const otherUsersActions = [
  { label: "View", value: permissionActionEnum.ACTION_VIEW },
  { label: "Create/Invite", value: permissionActionEnum.ACTION_CREATE },
  { label: "Edit", value: permissionActionEnum.ACTION_EDIT },
];

export const permissionStatusOptions = [
  {
    label: "Active",
    value: permissionStatusEnum.STATUS_ACTIVE,
    color: "green",
  },
  {
    label: "Inactive",
    value: permissionStatusEnum.STATUS_INACTIVE,
    color: "gray",
  },
  {
    label: "Deleted",
    value: permissionStatusEnum.STATUS_DELETED,
    color: "red",
  },
];

export const backgroundTypeOptions = [
  { label: "Dark", value: backgroundTypeEnum.BACKGROUND_DARK },
  { label: "Light", value: backgroundTypeEnum.BACKGROUND_LIGHT },
];

export const leaseTypeOptions = [
  { label: "Long-Term", value: leaseTypeEnum.LONG_TERM_LEASE },
  { label: "Month-to-Month", value: leaseTypeEnum.MONTH_TO_MONTH_LEASE },
];

export const coverageInterestOptions = [
  {
    value: coverageInterestKeyMap.JUST_IN_CASE,
    label: "I want to be covered just in case something unexpected happens",
  },
  {
    value: coverageInterestKeyMap.BUYING_HOME,
    label:
      "I’m in the process of buying a home and might close during my lease term",
  },
  {
    value: coverageInterestKeyMap.UNSURE_BUILDING,
    label: "I’m unsure about the building or unit I signed with",
  },
  {
    value: coverageInterestKeyMap.JOB_QUIT_PLANS,
    label: "I may be changing jobs soon and will likely move if I do",
  },
  {
    value: coverageInterestKeyMap.RELOCATE_DUE_TO_JOB,
    label:
      "I might need to relocate in the middle of my lease due to my current job",
  },
  {
    value: coverageInterestKeyMap.MOVE_WITH_SOMEONE,
    label:
      "I want the option to move in or out with someone in the middle of my next lease",
  },
  {
    value: coverageInterestKeyMap.MOVING_TO_NEW_CITY,
    label: "I am considering moving to a new city soon",
  },
  {
    value: coverageInterestKeyMap.RECENT_MOVED_UNSURE_AREA,
    label: "I just moved to a new city and I’m unsure about the area I chose",
  },
  {
    value: coverageInterestKeyMap.LANDLORD_ISSUES,
    label:
      "I’ve had issues with previous landlords and want the option to leave",
  },
  {
    value: coverageInterestKeyMap.REQUIRES_VISA_INFO,
    label: "I’m on a temporary visa and may need to relocate mid-lease",
  },
  {
    value: coverageInterestKeyMap.CURRENT_STUDENT,
    label: "I am currently enrolled in school",
  },
  {
    value: coverageInterestKeyMap.RECENT_GRADUATE,
    label: "I just graduated from school and may need to relocate soon",
  },
  {
    value: coverageInterestKeyMap.MONTH_TO_MONTH_NOT_FOUND,
    label: "I was looking for a month-to-month lease but couldn’t find one",
  },
  {
    value: coverageInterestKeyMap.MOVE_CLOSER_FAMILY,
    label: "I might need to move out to be closer to family or relatives",
  },
  {
    value: coverageInterestKeyMap.OTHER,
    label: "Other",
  },
];

export const coverageTypeOptions = [
  { label: "Full Coverage", value: coverageTypeEnum.FULL },
  { label: "Limited Coverage", value: coverageTypeEnum.LIMITED },
];
